import type { IconSvgObject } from './types';

const Certificate01Icon: IconSvgObject = [
  ["path", { d: "M11 22H4.00002C2.89544 22 2.00001 21.1046 2.00002 20L2.00016 3.99998C2.00017 2.89542 2.89559 2 4.00016 2H18C19.1046 2 20 2.89543 20 4V6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 8H15M8 13H11", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.5 16.3727L15 22L18.5 20L22 22L20.5 16.3727M22 13.5C22 15.433 20.433 17 18.5 17C16.567 17 15 15.433 15 13.5C15 11.567 16.567 10 18.5 10C20.433 10 22 11.567 22 13.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Certificate01Icon;
